/* urs2go AI 客服浮窗 v0.1（2026-10-24）
 * 自包含：样式、DOM、会话全部在这一个文件里，不需要额外 CSS。
 * 依赖：后端 POST /api/chat、/api/escalate
 * 上下文：自动读 window.ShopifyAnalytics.meta.product.handle（商品页），否则留空。
 */
(function () {
  if (window.__urs2goAICS__) return;
  window.__urs2goAICS__ = true;

  var API = window.URS2GO_CS_API || "https://cs.urs2go.com:9443";   // 部署后可被 window 变量覆盖（本地预览用）
  var STORE_KEY = "urs2go_aics_session";
  var HISTORY_KEY = "urs2go_aics_history";

  function uuid() {
    if (crypto && crypto.randomUUID) return crypto.randomUUID();
    return "s-" + Date.now() + "-" + Math.random().toString(16).slice(2, 10);
  }
  function sid() {
    var v = localStorage.getItem(STORE_KEY);
    if (!v) { v = uuid(); localStorage.setItem(STORE_KEY, v); }
    return v;
  }
  function handle() {
    try {
      var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      if (m && m.product && m.product.handle) return m.product.handle;
    } catch (e) {}
    var p = location.pathname.match(/\/products\/([^\/?#]+)/);
    return p ? p[1] : "";
  }

  var css = `
  .u2g-btn{position:fixed;right:18px;bottom:18px;z-index:2147483000;width:56px;height:56px;
    border-radius:50%;background:#111;color:#fff;border:0;cursor:pointer;font-size:22px;
    box-shadow:0 6px 20px rgba(0,0,0,.25);display:flex;align-items:center;justify-content:center}
  .u2g-btn:hover{transform:translateY(-1px)}
  .u2g-panel{position:fixed;right:18px;bottom:84px;z-index:2147483000;width:360px;height:520px;
    max-height:calc(100vh - 110px);background:#fff;border-radius:14px;overflow:hidden;
    box-shadow:0 12px 40px rgba(0,0,0,.22);display:none;flex-direction:column;
    font:14px/1.45 -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;color:#111}
  .u2g-panel.open{display:flex}
  .u2g-head{background:#111;color:#fff;padding:12px 14px;display:flex;align-items:center;
    justify-content:space-between}
  .u2g-head b{font-size:14px;font-weight:600}
  .u2g-head span{font-size:11px;opacity:.7;display:block;margin-top:2px}
  .u2g-x{background:none;border:0;color:#fff;font-size:20px;cursor:pointer;line-height:1}
  .u2g-body{flex:1;overflow-y:auto;padding:12px;background:#fafafa}
  .u2g-msg{max-width:85%;margin:8px 0;padding:9px 12px;border-radius:12px;white-space:pre-wrap;
    word-wrap:break-word}
  .u2g-ai{background:#fff;border:1px solid #e5e5e5;border-bottom-left-radius:4px}
  .u2g-me{background:#111;color:#fff;margin-left:auto;border-bottom-right-radius:4px}
  .u2g-sys{background:#fff7e6;border:1px solid #f0c36d;font-size:12px;color:#7a5b00}
  .u2g-msg a{color:#0b57d0;text-decoration:underline;word-break:break-all}
  .u2g-foot{border-top:1px solid #eee;padding:10px;background:#fff}
  .u2g-in{display:flex;gap:8px}
  .u2g-in input{flex:1;border:1px solid #ddd;border-radius:9px;padding:9px 11px;font-size:14px;outline:0}
  .u2g-in input:focus{border-color:#111}
  .u2g-in button{border:0;background:#111;color:#fff;border-radius:9px;padding:0 14px;cursor:pointer}
  .u2g-in button:disabled{opacity:.4;cursor:default}
  .u2g-human{background:none;border:0;color:#666;font-size:12px;text-decoration:underline;
    cursor:pointer;margin-top:7px;padding:0}
  .u2g-tip{font-size:11px;color:#888;margin-top:6px}
  @media(max-width:480px){.u2g-panel{right:0;left:0;bottom:0;width:100%;height:78vh;
    max-height:78vh;border-radius:14px 14px 0 0}.u2g-btn{right:14px;bottom:14px}}
  `;

  var style = document.createElement("style");
  style.textContent = css;
  document.head.appendChild(style);

  var btn = document.createElement("button");
  btn.className = "u2g-btn";
  btn.setAttribute("aria-label", "Chat with us");
  btn.textContent = "💬";

  var panel = document.createElement("div");
  panel.className = "u2g-panel";
  panel.innerHTML =
    '<div class="u2g-head"><div><b>urs2go Support</b>' +
    '<span>Usually replies in seconds</span></div>' +
    '<button class="u2g-x" aria-label="Close">×</button></div>' +
    '<div class="u2g-body"></div>' +
    '<div class="u2g-foot"><div class="u2g-in">' +
    '<input type="text" placeholder="Type your question…" maxlength="1000">' +
    '<button>Send</button></div>' +
    '<div class="u2g-ef" style="display:none;margin-top:8px">' +
    '<div style="font-size:12px;color:#444;margin-bottom:5px">What email should we reply to?</div>' +
    '<div class="u2g-in"><input type="email" placeholder="you@example.com" maxlength="120">' +
    '<button>Send</button></div></div>' +
    '<button class="u2g-human">Talk to a human</button>' +
    '<div class="u2g-tip">AI assistant. For order issues we may ask for your order number.</div>' +
    '</div>';

  document.body.appendChild(btn);
  document.body.appendChild(panel);

  var body = panel.querySelector(".u2g-body");
  var input = panel.querySelector(".u2g-in input");
  var sendBtn = panel.querySelector(".u2g-in button");
  var humanBtn = panel.querySelector(".u2g-human");
  var ef = panel.querySelector(".u2g-ef");
  var efInput = ef.querySelector("input");
  var efBtn = ef.querySelector("button");

  function askEmail() {
    ef.style.display = "block";
    efInput.focus();
    body.scrollTop = body.scrollHeight;
  }

  function doEscalate() {
    var mail = (efInput.value || "").trim();
    if (!mail || mail.indexOf("@") < 1) { efInput.focus(); return; }
    efBtn.disabled = true;
    fetch(API + "/api/escalate", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ session_id: sid(), handle: handle(), email: mail, note: "widget" })
    }).then(function (r) { return r.json(); })
      .then(function (d) {
        ef.style.display = "none";
        if (d && d.ok) {
          add("Ticket #" + (d.ticket || "") + " created. We will reply to " + mail +
              " within one business day.", "u2g-sys");
        } else {
          add("Sorry, we could not create the ticket. Please email support@urs2go.com.", "u2g-sys");
        }
      })
      .catch(function () {
        ef.style.display = "none";
        add("Sorry, the connection dropped. Please email support@urs2go.com.", "u2g-sys");
      })
      .then(function () { efBtn.disabled = false; });
  }

  // 把文本里的 http(s) 链接变成 <a>（追踪号要给买家点得开）；出错就退回纯文本
  function fill(el, text) {
    var s = String(text == null ? "" : text);
    try {
      var re = /https?:\/\/[^\s<>"']+/g, last = 0, m;
      while ((m = re.exec(s))) {
        var url = m[0].replace(/[.,;:!?)\]]+$/, "");
        if (m.index > last) el.appendChild(document.createTextNode(s.slice(last, m.index)));
        var a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.rel = "noopener noreferrer";
        a.textContent = url;
        el.appendChild(a);
        last = m.index + url.length;
      }
      if (last < s.length) el.appendChild(document.createTextNode(s.slice(last)));
      if (!el.firstChild) el.textContent = s;
    } catch (e) {
      el.textContent = s;
    }
  }

  function add(text, cls) {
    var d = document.createElement("div");
    d.className = "u2g-msg " + cls;
    fill(d, text);
    body.appendChild(d);
    body.scrollTop = body.scrollHeight;
    return d;
  }

  // 恢复本页会话历史（只在本浏览器）
  try {
    var saved = JSON.parse(sessionStorage.getItem(HISTORY_KEY) || "[]");
    saved.forEach(function (m) { add(m.t, m.c === "ai" ? "u2g-ai" : "u2g-me"); });
  } catch (e) {}
  if (!body.children.length) {
    add("Hi! Ask me about sizing, materials, shipping or returns.", "u2g-ai");
  }

  function remember(text, c) {
    try {
      var arr = JSON.parse(sessionStorage.getItem(HISTORY_KEY) || "[]");
      arr.push({ t: text, c: c });
      sessionStorage.setItem(HISTORY_KEY, JSON.stringify(arr.slice(-40)));
    } catch (e) {}
  }

  function send() {
    var text = (input.value || "").trim();
    if (!text) return;
    input.value = "";
    add(text, "u2g-me");
    remember(text, "me");
    sendBtn.disabled = true;
    var thinking = add("…", "u2g-ai");

    fetch(API + "/api/chat", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        session_id: sid(), handle: handle(), message: text, page_url: location.href
      })
    })
      .then(function (r) {
        if (r.status === 429) {
          return r.json().then(function (e) {
            thinking.remove();
            add(e.detail || "Too many messages — please wait a moment.", "u2g-sys");
            throw new Error("rate-limited");
          });
        }
        return r.json();
      })
      .then(function (d) {
        thinking.remove();
        if (d.answer) {
          add(d.answer, "u2g-ai");
          remember(d.answer, "ai");
        }
        if (d.escalate) { askEmail(); }
      })
      .catch(function (err) {
        thinking.remove();
        if (err && err.message === "rate-limited") { return; }
        add("Sorry, the connection dropped. Please email support@urs2go.com.", "u2g-sys");
      })
      .then(function () { sendBtn.disabled = false; input.focus(); });
  }

  btn.addEventListener("click", function () {
    panel.classList.toggle("open");
    if (panel.classList.contains("open")) input.focus();
  });
  panel.querySelector(".u2g-x").addEventListener("click", function () {
    panel.classList.remove("open");
  });
  sendBtn.addEventListener("click", send);
  input.addEventListener("keydown", function (e) { if (e.key === "Enter") send(); });

  humanBtn.addEventListener("click", askEmail);
  efBtn.addEventListener("click", doEscalate);
  efInput.addEventListener("keydown", function (e) { if (e.key === "Enter") doEscalate(); });
})();
